import { changesData, stepLabelFor } from "./callHandlers";
import { currentToolName } from "./retiredToolNames";
import type { ToolResult } from "./tools";

export type CompletedCall = { name: string; result: ToolResult };

export type TurnProgress = { done: CompletedCall[]; notStarted: string[] };

export const emptyTurnProgress = (): TurnProgress => ({ done: [], notStarted: [] });

export const CONTINUE_HINT = "Skriv «fortsett» for å gå videre.";

export const stopSummary = (progress: TurnProgress, answerCut = false): string => {
  const done = grouped(progress.done.map((call) => `${labelOf(call.name)}: ${statusOf(call)}`));
  const notStarted = grouped(progress.notStarted.map(labelOf));
  const saved = progress.done.some((call) => changesData(currentToolName(call.name)) && call.result.ok);
  if (done.length === 0 && notStarted.length === 0) {
    const stopped = answerCut ? "Du stoppet svaret før det var ferdig skrevet." : "Du stoppet oppgaven før noe ble gjort.";
    return [`${stopped} Ingenting er endret.`, CONTINUE_HINT].join("\n\n");
  }
  return [
    done.length ? `Du stoppet oppgaven. Dette ble gjort før stoppet:\n${bullets(done)}` : "Du stoppet oppgaven.",
    notStarted.length ? `Dette ble ikke startet:\n${bullets(notStarted)}` : "Det som gjenstår, er ikke gjort.",
    saved ? "Det som er lagret, er beholdt." : "Ingenting er endret.",
    CONTINUE_HINT,
  ].join("\n\n");
};

const labelOf = (name: string): string => stepLabelFor(currentToolName(name));

const statusOf = ({ name, result }: CompletedCall): string => {
  const writes = changesData(currentToolName(name));
  if (result.ok) return writes ? "lagret" : "ferdig";
  if (result.deviationCode === "USER_DECLINED") return "du avviste endringen";
  return writes ? "ikke lagret" : "mislyktes";
};

const grouped = (lines: string[]): string[] => {
  const counts = new Map<string, number>();
  lines.forEach((line) => counts.set(line, (counts.get(line) ?? 0) + 1));
  return [...counts].map(([line, count]) => (count > 1 ? `${line} (${count} ganger)` : line));
};

const bullets = (lines: string[]): string => lines.map((line) => `- ${line}`).join("\n");
